import {match} from 'ts-pattern';

import type {Message} from './types';

/**
 * Returns tags only when an importer message has newly reached SUCCESS in this query cache entry.
 *
 * Polling repeatedly returns already-completed messages. Invalidating their catalog tags on every
 * response would refetch all subscribed catalog queries forever.
 */
export function getCompletedImporterCatalogTags(
  messages: Message[],
  previousMessages: Message[] = []
) {
  const previouslyCompletedIds = new Set(
    previousMessages.filter((message) => message.status === 'SUCCESS').map((message) => message.id)
  );

  return [
    ...new Set(
      messages.flatMap((message) => {
        if (message.status !== 'SUCCESS' || previouslyCompletedIds.has(message.id)) {
          return [];
        }
        return match(message.useCaseType)
          .with('importNissanPriceList', () => ['PromptBridgeNissanPart'] as const)
          .with('importHondaPartsPriceList', () => ['PromptBridgeHondaPart'] as const)
          .with('importHondaRecall', () => ['PromptBridgeHondaRecall'] as const)
          .otherwise(() => []);
      })
    ),
  ];
}
